'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/social/SocialBanner.tsx
import { Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var SocialBannerSection = ({ section }) => {
  var _a, _b, _c;
  const socialBanner = section.contentCollection.items[0];
  if (!socialBanner) return null;
  return /* @__PURE__ */ jsxs(
    DecoratedSection_default,
    {
      section,
      "data-logo": !!socialBanner.logoImage,
      className: "container gap-6 text-center data-[logo=true]:flex data-[logo=true]:flex-col data-[logo=true]:justify-between data-[logo=true]:text-start data-[logo=true]:md:flex-row data-[logo=true]:md:items-center",
      "data-testid": `section_social_banner_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
          /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: socialBanner.title }),
          /* @__PURE__ */ jsx(
            "ul",
            {
              "data-logo": !!socialBanner.logoImage,
              className: "flex flex-wrap items-center justify-center gap-6 data-[logo=true]:justify-start",
              children: (_c = (_b = (_a = socialBanner.socialLinks) == null ? void 0 : _a.iconLinksCollection) == null ? void 0 : _b.items) == null ? void 0 : _c.map((link) => /* @__PURE__ */ jsx("li", { className: "rounded-md", children: /* @__PURE__ */ jsx(
                ContentfulButton_default,
                {
                  link,
                  rel: "noreferrer noopener",
                  className: "social_media_follow shrink-0 overflow-hidden rounded-md !p-1",
                  "data-category": link.label,
                  rounded: true
                }
              ) }, link.id))
            }
          )
        ] }),
        socialBanner.logoImage && /* @__PURE__ */ jsx(
          ContentfulMedia_default,
          {
            media: socialBanner.logoImage,
            className: "mx-auto w-full max-w-xs md:mx-0"
          }
        )
      ]
    }
  );
};
var SocialBanner_default = SocialBannerSection;

export {
  SocialBanner_default
};
//# sourceMappingURL=chunk-UT2LXEOT.mjs.map